import { REFRESH_CACHE_ON_BUILD } from './apiCacheConfig';
import { apiIDBCache } from './apiIDBCache';
import { clearAllI18nextTranslations } from './i18nextIDBCache';

const CACHE_BUILD_VERSION_KEY = 'kn_idb_cache_build_version';

export function getAppReleaseVersion() {
  return window.appinfo?.releaseVersion
    || localStorage.getItem('app_version')
    || null;
}

export function getStoredCacheBuildVersion() {
  return localStorage.getItem(CACHE_BUILD_VERSION_KEY);
}

/**
 * Clears broker + i18next IndexedDB caches when a new build is deployed.
 * Uses releaseVersion from public/version.js (generated on each `npm run build`).
 */
export async function refreshCachesOnBuildChange() {
  if (!REFRESH_CACHE_ON_BUILD) return false;

  const releaseVersion = getAppReleaseVersion();
  if (!releaseVersion) return false;

  const storedVersion = getStoredCacheBuildVersion();
  const isNewBuild = Boolean(storedVersion && storedVersion !== releaseVersion);

  if (isNewBuild) {
    console.info(
      '[cacheBuildRefresh] New build detected, clearing IndexedDB caches:',
      storedVersion,
      '→',
      releaseVersion
    );
    await Promise.all([
      apiIDBCache.clearAll(),
      clearAllI18nextTranslations(),
    ]);
  }

  localStorage.setItem(CACHE_BUILD_VERSION_KEY, releaseVersion);
  return isNewBuild;
}
